<template>
  <div class="copyrightFooter">
    &copy; {{ copyrightYear  }} EnerMAN Technologies Private Limited. All rights reserved.
    This site is protected by reCAPTCHA and the Google
    <a href="https://www.google.com/policies/privacy/" target="_blank">Privacy Policy</a> and
    <a href="https://www.google.com/policies/terms/" target="_blank">Terms of Service</a> apply.
  </div>
</template>

<script>
export default {
  name: 'CopyrightFooter',
  computed: {
    copyrightYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.copyrightFooter {
  background-color: var(--v-primary-base) !important;
  color: #d6d6d6;
  opacity: .93;
  font-size: 12px;
  position: fixed;
  bottom: 0px !important;
  text-align: center !important;
  text-wrap: wrap;
  padding: 15px;
  width: 100%;
}

.copyrightFooter a {
  color: #868686;
}
</style>